module.exports = withSideEffect;